/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AbstractStep } from './abstractStep';
import { MarketingScenarioProcess } from './marketingScenarioProcess';
import { TransactionalScenarioProcess } from './transactionalScenarioProcess';

export interface ScenarioVersion { 
    id?: string;
    scenarioId?: string;
    version?: number;
    process?: MarketingScenarioProcess | TransactionalScenarioProcess;
    status?: ScenarioVersion.StatusEnum;
    createdAt?: Date;
    updatedAt?: Date;
    steps?: Array<AbstractStep>;
}
export namespace ScenarioVersion {
    export type StatusEnum = 'DRAFT' | 'PUBLISH' | 'STOPPED';
    export const StatusEnum = {
        DRAFT: 'DRAFT' as StatusEnum,
        PUBLISH: 'PUBLISH' as StatusEnum,
        STOPPED: 'STOPPED' as StatusEnum
    };
}